"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsViewFilters = void 0;
var ReportsViewFilters;
(function (ReportsViewFilters) {
    ReportsViewFilters["BasicReports"] = "Basic reports";
    ReportsViewFilters["CustomReports"] = "Custom reports";
    ReportsViewFilters["FuelReports"] = "Fuel reports";
    ReportsViewFilters["EmissionReports"] = "Emission reports";
    ReportsViewFilters["ProductivityReports"] = "Productivity reports";
    ReportsViewFilters["LogisticsReports"] = "Logistics reports";
    ReportsViewFilters["MaintenanceReports"] = "Maintenance reports";
})(ReportsViewFilters = exports.ReportsViewFilters || (exports.ReportsViewFilters = {}));
//# sourceMappingURL=filters.js.map